import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/wxBill/getTotalBillDetail', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/goodsorder/exportAccountDetailExcel', data, {
    trim: true,
    download: true
  })
}

// 导出Excel
export function exportNotBikeExcel (data) {
  return request.post('/business/wxBillDetail/exportNotBikeExcel', data, {
    trim: true,
    download: true
  })
}
